module.exports = __webpack_public_path__ + "static/media/big_planet.e1b6c056.png";